import * as yup from 'yup';

// Redemption popup validation schema
export const redemptionSchema = yup.object({
  saaszillacode: yup.string().required('Code required'),
}).required();
